import { render, staticRenderFns } from "./HolidayAddEditModal.vue?vue&type=template&id=2282055a"
import script from "./HolidayAddEditModal.vue?vue&type=script&lang=js"
export * from "./HolidayAddEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports